/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryMethodDetailedResponse } from '../../models/delivery-method-detailed-response';

export interface GetDeliveryMethod$Params {
  deliveryMethodId: string;
}

export function getDeliveryMethod(http: HttpClient, rootUrl: string, params: GetDeliveryMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryMethodDetailedResponse>> {
  const rb = new RequestBuilder(rootUrl, getDeliveryMethod.PATH, 'get');
  if (params) {
    rb.path('deliveryMethodId', params.deliveryMethodId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryMethodDetailedResponse>;
    })
  );
}

getDeliveryMethod.PATH = '/delivery/methods/{deliveryMethodId}';
